<template>
	<div class="about">
		<div class="logo">
			<slot name="logo"></slot>
		</div>
		<slot name="main_part">
			<div class="left_side">
				<h1>
					<slot name="headline"></slot>
				</h1>
				<div class="f25">
					<slot name="description_below_headline"></slot>
				</div>
				<div class="f15">
					<slot name="find_out_more_button_and_explanation"></slot>
				</div>
				<slot name="info"></slot>
			</div>
		</slot>
		<div :class="[cssClass]"></div>
		<slot name="note"></slot>
	</div>
</template>

<script>
export default {
	name: 'BaseTopBanner',
	props: {
		cssClass: {
			type: String,
			default: ''
		}
	}
}
</script>

<style scoped></style>
